export function promiseWithTimeout<T> (promise: Promise<T>, ms: number): Promise<T> {
    return Promise.race([
        promise,
        new Promise<T>((_, reject) => { setTimeout(() => reject(new Error(`Timeout after ${ms}ms`)), ms); }),
    ]);
}
